import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  position: fixed;
  top: 0;
  left: ${(p) => p.theme.spacing(6.5)};
  width: 0;
  opacity: 0;
  background: ${(p) => p.theme.palette.common.white};
  height: 100vh;
  transition: all 0.2s ease-in-out;
  border-right: 1px solid ${(p) => p.theme.palette.primary[100]};
  &.open {
    width: ${(p) => p.theme.spacing(24)};
    opacity: 1;
  }
`;

export const Logo = styled('img')``;
